<script setup>
import CFContentPlaceholders from '@/shared/components/CFContentPlaceholders.vue';

defineProps({
    count: {
        type: Number,
        default: 3,
    },
});
</script>

<template>
    <CFContentPlaceholders class="space-y-6">
        <template
            v-for="i in count"
            :key="i"
        >
            <div class="content-placeholders-heading content-placeholders-spacing">
                <div class="content-placeholders-heading__content">
                    <div class="content-placeholders-heading__avatar content-placeholders" />
                    <div class="content-placeholders-heading__title">
                        <div class="content-placeholders w-full" />
                    </div>
                    <div class="content-placeholders-heading__button content-placeholders" />
                </div>
            </div>
        </template>
    </CFContentPlaceholders>
</template>

<style scoped>
@reference "@css/app.css";

.content-placeholders-heading {
    @apply flex border-b border-gray-200 py-6;

    .content-placeholders-heading__avatar {
        @apply size-8 rounded-full;
    }

    .content-placeholders-heading__content {
        @apply flex flex-1 items-center justify-center gap-4;
    }

    .content-placeholders-heading__title {
        @apply flex grow flex-col gap-y-3 pr-4;
    }

    .content-placeholders-heading__title > div {
        @apply overflow-hidden;
    }

    .content-placeholders-heading__button {
        @apply h-6 w-24;
    }
}
</style>
